import { cn } from "@/lib/utils";
import { cva, type VariantProps } from "class-variance-authority";
import React from "react";

export const typographyVariants = cva("text-xl", {
	variants: {
		variant: {
			h1: "scroll-m-20 text-4xl font-bold tracking-tight ",
			h2: "scroll-m-20 pb-2 text-3xl font-semibold tracking-tight first:mt-0",
			h3: "scroll-m-20 text-2xl font-semibold tracking-tight",
			h4: "text-xl font-semibold tracking-tight",
			h5: "text-base font-medium font-semibold tracking-tight",
			h6: "text-sm font-medium font-semibold tracking-tight",
			p: "leading-7 text-sm ",
		},
		color: {
			primary: "text-textDark",
			"primary-light": "text-textLight",
			"primary-accent": "text-primary-600",
		},
		weight: {
			normal: "font-normal",
			medium: "font-medium",
			semibold: "font-semibold",
		},
	},
	defaultVariants: {
		variant: "h1",
		color: "primary",
	},
});

export interface TypographyProps
	extends Omit<React.HTMLAttributes<HTMLHeadingElement>, "color">,
		VariantProps<typeof typographyVariants> {}

const Typography = React.forwardRef<HTMLHeadingElement, TypographyProps>(
	({ className, variant, color, weight, ...props }, ref) => {
		const Comp = variant || "p";
		return (
			<Comp
				className={cn(
					typographyVariants({ variant, color, weight, className }),
				)}
				ref={ref}
				{...props}
			/>
		);
	},
);
Typography.displayName = "H1";

export default Typography;
